import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import TitleLogo from '../Assets/Images/Solar_TitleLogo.png';
import MenachiLogo from '../Assets/Images/SolarMenachi-Logo.png';
import { FaBars, FaTimes } from 'react-icons/fa';

const navItems = [
  { label: 'Home', id: 'home' },
  { label: 'About', id: 'about' },
  { label: 'Our Services', id: 'services' },
  { label: 'Gallery', id: 'gallery' },
  { label: 'Project Overview', path: '/overview' },
  { label: 'Contact', id: 'contact' },
];

const Header2 = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isHomePage, setIsHomePage] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkHomePage = () => {
      setIsHomePage(location.pathname === '/' || location.hash === '#home');
    };

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    checkHomePage();
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('hashchange', checkHomePage);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('hashchange', checkHomePage);
    };
  }, [location]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavigation = (item) => {
    if (item.path) {
      navigate(item.path);
    } else if (item.id) {
      const element = document.getElementById(item.id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else {
        window.location.hash = item.id;
      }
    }
    setIsMenuOpen(false);
  };

  return (
    <header
      className="fixed top-0 left-0 w-full text-white shadow-lg z-50"
      style={{
        backgroundImage:
          'linear-gradient(to bottom, #77a130, #8cb14d, #a1c169, #b5d184, #cae2a0)',
      }}
    >
      <div className="container mx-auto px-4 py-2 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <img
            src={TitleLogo}
            alt="SolarMore Logo"
            className="h-[50px] w-auto max-w-[80px] object-contain"
          />
          <div className="text-left">
            <div className="text-base sm:text-lg font-semibold text-white">SolarMore Solutions</div>
            <div className="text-xs sm:text-sm text-white">Green Energy Pvt. Ltd.</div>
          </div>
        </div>

        <nav className="hidden sm:flex sm:space-x-6">
          {navItems.map((item) => (
           <button
  key={item.label}
  onClick={() => handleNavigation(item)}
  className="text-white font-semibold px-4 py-2 rounded-lg bg-[#70962f19] hover:bg-[#597d2496] hover:text-white hover:shadow-lg hover:-translate-y-1 transform transition duration-300 ease-in-out"
>
  {item.label}
</button>

          ))}
        </nav>

        <img
          src={MenachiLogo}
          alt="Menachi Logo"
          className="h-[80px] w-auto max-w-[80px] object-contain hidden sm:block"
        />

        <button
          className="sm:hidden text-white focus:outline-none"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <FaTimes className="w-6 h-6" /> : <FaBars className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <nav className="sm:hidden w-full px-6 py-4 space-y-3 border-t border-white/20" style={{
        backgroundImage:
          'linear-gradient(to bottom, #77a130, #8cb14d, #a1c169, #b5d184, #cae2a0)',
      }}>
          {navItems.map((item) => (
            <button
              key={`mobile-${item.label}`}
              onClick={() => handleNavigation(item)}
              className="w-full text-left text-white text-base font-medium py-2 transition-all duration-300"
            >
              {item.label}
            </button>
          ))}
        </nav>
      )}

      {/* Floating Mobile Menu on Scroll */}
      {isMenuOpen && isScrolled && isHomePage && (
        <nav className="sm:hidden fixed top-[70px] left-0 right-0 mx-auto max-w-screen-md  px-6 py-4 space-y-3 m-2 rounded-b-lg shadow-lg z-50" style={{
        backgroundImage:
          'linear-gradient(to bottom, #77a130, #8cb14d, #a1c169, #b5d184, #cae2a0)',
      }}>
          {navItems.map((item) => (
            <button
              key={`float-${item.label}`}
              onClick={() => handleNavigation(item)}
              className="w-full text-left text-white text-base font-medium py-2 transition-all duration-300"
            >
              {item.label}
            </button>
          ))}
        </nav>
      )}
    </header>
  );
};

export default Header2;
